export const faqData = [
  {
    id: 1,
    question:
      "What types of loans can I calculate using the Car Loan EMI Calculator?",
    answer:
      "The Car Loan EMI Calculator is designed specifically for car loans. It helps estimate monthly payments based on the loan amount, interest rate, and tenure.",
  },
  {
    id: 2,
    question: "Does the calculator include prepayment and foreclosure charges?",
    answer:
      "The calculator provides estimates for EMI, total interest, and repayment, but additional prepayment and foreclosure charges may need to be calculated separately. Always check with the lender for specific charges.",
  },
  {
    id: 3,
    question: "Can I calculate EMIs for used car loans?",
    answer:
      "Yes, the calculator can be used to estimate EMIs for both new and used car loans. Just enter the appropriate loan amount and terms based on the used car's value.",
  },
];
